import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'FileNameFromUrl'
})
export class FileNameFromUrlPipe implements PipeTransform {

  transform(url: string): any {
    const urla = url.split('/');
    return urla[urla.length - 1];
  }

}
